/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ocr_Psm_AutoInputs */



/**
* | output |
* | --- |
* | "Automatic (Full Page)" |
*
* @param {Ocr_Psm_AutoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ocr_psm_auto = /** @type {((inputs?: Ocr_Psm_AutoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ocr_Psm_AutoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Automatique (Page complète)")
	if (locale === "de") return /** @type {LocalizedString} */ ("Automatisch (Vollbild)")
	if (locale === "it") return /** @type {LocalizedString} */ ("Automatico (Pagina intera)")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Автоматический (полная страница)")
	if (locale === "es") return /** @type {LocalizedString} */ ("Automático (Página completa)")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("自动（整页）")
	if (locale === "ja") return /** @type {LocalizedString} */ ("自動（全ページ）")
	if (locale === "hi") return /** @type {LocalizedString} */ ("स्वचालित (पूर्ण पृष्ठ)")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Automático (Página inteira)")
	return /** @type {LocalizedString} */ ("Automatic (Full Page)")
});